module.exports = __webpack_public_path__ + "img/pediatrics.472abef9.svg";